import { AUTO_PATH_SOURCE } from './constants';
import { safeSetSourceData } from './utils';
import { debug } from '../../../utils/debug';

// Simple GeoJSON conversion
const pathToGeoJSON = (path, locations) => {
  if (!path || path.length === 0) {
    return { type: 'FeatureCollection', features: [] };
  }

  if (path.vehiclePaths) {
    // Multi-vehicle path
    return { 
      type: 'FeatureCollection', 
      features: path.vehiclePaths.map(vehicle => ({
        type: 'Feature',
        properties: { 
          color: vehicle.color || '#1f77b4',
          vehicleId: vehicle.vehicle_id 
        },
        geometry: {
          type: 'LineString',
          coordinates: vehicle.path.map(point => {
            // Handle different point formats
            if (point.lng !== undefined && point.lat !== undefined) {
              return [point.lng, point.lat];
            } else if (point.longitude !== undefined && point.latitude !== undefined) {
              return [point.longitude, point.latitude];
            } else if (typeof point === 'string') {
              // If point is an ID, find the location
              const location = locations.find(loc => loc.id === point);
              return location ? [location.longitude, location.latitude] : null;
            }
            return null;
          }).filter(Boolean)
        }
      }))
    };
  } else {
    // Single path
    const coordinates = path
      .map(id => locations.find(loc => loc.id === id))
      .filter(Boolean)
      .map(loc => [loc.longitude, loc.latitude]);
      
    return {
      type: 'FeatureCollection',
      features: [{
        type: 'Feature',
        properties: { color: '#1f77b4' },
        geometry: { type: 'LineString', coordinates }
      }]
    };
  }
};

// Update auto path on map
export const updateAutoPath = ({
  map,
  mapReady,
  sourcesReady,
  autoPath,
  locations,
  shouldShowAutoPath
}) => {
  debug('VRP-AUTO', 'Updating auto path', { 
    pathLength: Array.isArray(autoPath) ? autoPath.length : 0,
    hasVehiclePaths: Boolean(autoPath?.vehiclePaths),
    vehiclePathsCount: autoPath?.vehiclePaths?.length || 0,
    shouldShowAutoPath,
    mapReady,
    sourcesReady
  });

  if (!map || !mapReady || !sourcesReady) {
    debug('VRP-AUTO', 'Map not ready');
    return;
  }

  if (!shouldShowAutoPath || !autoPath || autoPath.length === 0) {
    safeSetSourceData(map, mapReady, sourcesReady, AUTO_PATH_SOURCE, { type: 'FeatureCollection', features: [] });
    return;
  }

  try {
    const pathData = pathToGeoJSON(autoPath, locations);
    safeSetSourceData(map, mapReady, sourcesReady, AUTO_PATH_SOURCE, pathData);
    debug('VRP-AUTO', 'Auto path updated successfully');
  } catch (error) {
    debug('VRP-AUTO', 'Error updating auto path', error);
  }
};